/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const TumblrIcon = ({ size, ...props }) => (React.createElement("svg", { viewBox: "0 0 12 18", fill: "currentColor", width: size || '1em', height: size || '1em', ...props },
    React.createElement("path", { id: "a", fill: "currentColor", d: "M6.5,10.7l0.1-3h4.2V4.6H6.6c0.1-2.5,0.1-3.8,0-3.8H4.2c-0.4,2.3-1.8,4.1-4,4.6L0.1,7.7h2.8v4.7 c0.2,2.2,0.7,3.6,1.5,4.3c1.1,0.7,1.8,1,3.8,1c0.5,0,1,0,1.6,0l1.5-0.9v-2.7c-2,0.6-3.4,0.6-4.3,0C6.6,13.8,6.4,12.6,6.5,10.7 L6.5,10.7z" })));
TumblrIcon.displayName = 'TumblrIcon';
export default TumblrIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=TumblrIcon.js.map